import { readStoredLocale } from './locale-storage';
import { AppLocale, normalizeLocale, SOURCE_LOCALE } from './locales';

function browserLanguages(): readonly string[] {
  const { languages, language } = window.navigator;
  return languages && languages.length > 0 ? languages : [language];
}

/**
 * Язык интерфейса при старте: сохранённый выбор → первое поддерживаемое из **всех**
 * предпочтений браузера → исходный русский (полное покрытие и основная аудитория).
 *
 * `@lingui/detect-locale` не подходит: его `fromNavigator` смотрит только на
 * `navigator.language`, и при `['de-DE', 'en-US']` интерфейс остался бы русским.
 */
export function detectLocale(): AppLocale {
  const stored = readStoredLocale();
  if (stored) {
    return stored;
  }

  for (const tag of browserLanguages()) {
    const locale = normalizeLocale(tag);
    if (locale) {
      return locale;
    }
  }

  return SOURCE_LOCALE;
}
